import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { RepromptIcon } from '@utilities';
import { fastTrackStatus, fastTrackErrorStatuses } from '@helpers';

import { getFastTrackStatusMessage } from './utilities/helpers';

import styles from './_index.module.scss';

const FastTrackStatus = ({ fastTrack, onComplete, showCompleteMessage, showTruncatedMessage }) => {
  const doneStatuses = [fastTrackStatus.COMPLETED, ...fastTrackErrorStatuses];
  const flows = useSelector((state) => state?.websocket?.flows);

  const [data, setData] = useState(fastTrack);

  useEffect(() => {
    const flow = flows?.find((flow) => flow?.id === data?.id);

    if (flow) {
      setData(flow);
    }

    if (doneStatuses.includes(flow?.status)) onComplete();
  }, [flows]);

  if (!doneStatuses.includes(data?.status)) {
    return (
      <div className={styles['fast-track-status']}>
        <RepromptIcon className={styles['fast-track-status-loading-icon']} />
        {getFastTrackStatusMessage({ data, showTruncatedMessage })}
        ...
      </div>
    );
  }

  if (showCompleteMessage) {
    return getFastTrackStatusMessage({ data, showTruncatedMessage });
  }

  return null;
};

FastTrackStatus.defaultProps = {
  onComplete: () => {},
};

FastTrackStatus.propTypes = {
  fastTrack: PropTypes.object,
  onComplete: PropTypes.func,
  showCompleteMessage: PropTypes.bool,
  showTruncatedMessage: PropTypes.bool,
};

export default FastTrackStatus;
